import {getMediaUrl} from '@/shared/lib/getMediaUrl';
import {type LocalizationKey} from '@/shared/services/i18n';

type LoginCard = {
  image: string;
  titleKey: LocalizationKey;
  descriptionKey: LocalizationKey;
};

export const LOGIN_CARD: LoginCard[] = [
  {
    image: getMediaUrl('landing/single.webp'),
    titleKey: 'landing_advantage_70_users_title',
    descriptionKey: 'landing_advantage_join_community_description',
  },
  {
    image: getMediaUrl('landing/ver.webp'),
    titleKey: 'landing_advantage_87_users_title',
    descriptionKey: 'landing_advantage_ensure_safer_description',
  },
  {
    image: getMediaUrl('landing/girl.webp'),
    titleKey: 'landing_advantage_60_users_title',
    descriptionKey: 'landing_advantage_creates_inclusive_description',
  },
];
